<template>
  <div class="secret">
    <div class="wrap">
      <h3>授权访问</h3>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="访问密码" prop="title">
          <el-input v-model="ruleForm.pwd" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import "element-ui/lib/theme-chalk/index.css";
export default {
  name: "secret",
  data() {
    return {
      ruleForm: {
        pwd: "",
      },
      rules: {
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur"
          }
        ],
      }
    };
  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.getUrl(this.ruleForm).then(res => {
            if (res.code == 200) {
                window.location.href = res.data; 
            }
          });
        } else {
          //   console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="less">
.secret {
    width: 85%;
    margin: 0 auto;
}
</style>